import { combineReducers } from "redux";
import TerminalLine from "../../../types/TerminalLine";
import { TerminalActionKey } from "../../actions/ActionKeys";
import { TerminalAction } from "../../actions/terminal";

const lines = (
  state: TerminalLine[] = [],
  action: TerminalAction
): TerminalLine[] => {
  switch (action.type) {
    case TerminalActionKey.APPEND_TERMINAL:
      return [...state, ...action.payload.lines];
    case TerminalActionKey.CLEAR_TERMINAL:
      return [];
    default:
      return state;
  }
};

const isExpanded = (
  state: boolean = false,
  action: TerminalAction
): boolean => {
  switch (action.type) {
    case TerminalActionKey.SET_TERMINAL_EXPANDED:
      return action.payload.isExpanded;
    default:
      return state;
  }
};

export const terminal = combineReducers({
  lines,
  isExpanded,
});
